function h(t, e) {
  var n = -1, l = t.length;
  for (e || (e = Array(l)); ++n < l; )
    e[n] = t[n];
  return e;
}
export {
  h as default
};
